import { createContext, useState } from "react";
const ToastContext = createContext();

export function ToastContextProvider({ children }) {
  const [toastList, setToastList] = useState([]);

  const removeFromToastFromList = (index) => {
    const tempList = [...toastList];
    tempList.splice(index, 1);
    setToastList(tempList);
  };

  const emptyToastList = () => {
    setToastList([]);
  };

  const insertIntoToastList = (
    text,
    status,
    unique,
    selfDestructible,
    executable,
    executableFunction
  ) => {
    //Obavestenja koja su unique se dodaju samo jednom
    if (unique) {
      const hasDuplicate = toastList.some((toast) => toast.unique === unique);
      if (hasDuplicate) {
        return;
      }
    }
    //executable oznacava da li se ocekuje da se klikom na toast izvrsi neka funkcija
    //executableFunction je funkcija koja se izvrsava klikom na toast
    setToastList((prev) => [
      ...prev,
      {
        text: text,
        status: status,
        unique: unique,
        selfDestructible: selfDestructible,
        executable: executable,
        executableFunction: executableFunction,
      },
    ]);
  };

  const valueToShare = {
    toastList: toastList,
    emptyToastList: emptyToastList,
    removeFromToastFromList: removeFromToastFromList,
    insertIntoToastList: insertIntoToastList,
    setToastList: setToastList,
  };

  return (
    <ToastContext.Provider value={valueToShare}>
      {children}
    </ToastContext.Provider>
  );
}

export default ToastContext;
